// @ts-nocheck
/**
 * بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ
 * Shiffa Premium Animations Controller
 * Scroll Reveals · Parallax · Cursor Glow · Counter Animations
 * Modern Islamic Art Enhanced Experience
 */

(function () {
  'use strict';

  // =============================================
  // 1. SCROLL REVEAL OBSERVER
  // Animate elements as they enter viewport
  // =============================================

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          if (!entry.target.dataset.repeatReveal) {
            revealObserver.unobserve(entry.target);
          }
        }
      });
    },
    {
      threshold: 0.02,
      rootMargin: '0px 0px 100px 0px',
    }
  );

  // Auto-apply scroll reveal to elements
  function initScrollReveals() {
    // Make ALL sections visible immediately — no blackout
    document.querySelectorAll('.shopify-section').forEach((section) => {
      section.classList.add('section-visible');
    });

    // Mark all scroll-reveal elements as revealed immediately
    // This prevents any hidden content when dragging the scrollbar fast
    document.querySelectorAll('.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right, .scroll-reveal-scale, .scroll-reveal-rotate').forEach((el) => {
      el.classList.add('revealed');
    });

    // Do NOT dynamically add scroll-reveal to elements — it causes blackout on fast scroll
  }

  // =============================================
  // 2. SECTION VISIBILITY OBSERVER
  // Fade in entire sections
  // =============================================

  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-visible');
          sectionObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  // =============================================
  // 3. CURSOR GLOW EFFECT
  // Subtle gold glow follows mouse on desktop
  // =============================================

  function initCursorGlow() {
    // Disabled: cursor glow runs a constant rAF loop and hurts scroll performance
    return;
    if (window.innerWidth < 750) return;

    const glow = document.createElement('div');
    glow.className = 'cursor-glow';
    document.body.appendChild(glow);

    let mouseX = 0,
      mouseY = 0,
      glowX = 0,
      glowY = 0;

    document.addEventListener(
      'mousemove',
      (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
      },
      { passive: true }
    );

    // Smooth follow with requestAnimationFrame
    function animateGlow() {
      glowX += (mouseX - glowX) * 0.08;
      glowY += (mouseY - glowY) * 0.08;
      glow.style.left = glowX + 'px';
      glow.style.top = glowY + 'px';
      requestAnimationFrame(animateGlow);
    }

    animateGlow();

    // Hide glow when mouse leaves window
    document.addEventListener('mouseleave', () => {
      glow.style.opacity = '0';
    });
    document.addEventListener('mouseenter', () => {
      glow.style.opacity = '1';
    });
  }

  // =============================================
  // 4. COUNTER ANIMATION
  // Animate numbers counting up
  // =============================================

  function animateCounter(element) {
    const target = parseInt(element.dataset.count || element.textContent, 10);
    if (isNaN(target)) return;

    const duration = 2000;
    const startTime = performance.now();
    const suffix = element.dataset.suffix || '';
    const prefix = element.dataset.prefix || '';

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(eased * target);

      element.textContent = prefix + current.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        element.textContent = prefix + target.toLocaleString() + suffix;
      }
    }

    requestAnimationFrame(update);
  }

  // Observe counter elements
  function initCounters() {
    const counterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll('.counter-number, [data-count]').forEach((el) => {
      counterObserver.observe(el);
    });
  }

  // =============================================
  // 5. PARALLAX SCROLL EFFECT
  // Subtle parallax on hero images
  // =============================================

  function initParallax() {
    // Disabled: parallax causes scroll jank by recalculating transforms every frame
    return;
  }

  // =============================================
  // 6. SMOOTH HEADER SCROLL STATE
  // Removed: theme's native sticky header handles this
  // =============================================

  // =============================================
  // 7. MAGNETIC BUTTON EFFECT
  // Buttons slightly follow cursor on hover
  // =============================================

  function initMagneticButtons() {
    if (window.innerWidth < 750) return;

    document.querySelectorAll('.button--primary, .btn-primary, a.cta-button.primary').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        btn.style.transform = `translate(${x * 0.15}px, ${y * 0.15}px) scale(1.03)`;
      });

      btn.addEventListener('mouseleave', () => {
        btn.style.transform = 'translate(0, 0) scale(1)';
      });
    });
  }

  // =============================================
  // 8. TEXT SPLIT REVEAL
  // Removed: splitting text into character spans hurt LCP
  // =============================================

  // =============================================
  // 9. SMOOTH ANCHOR SCROLLING
  // Premium scroll to anchor links
  // =============================================

  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const targetId = anchor.getAttribute('href');
        if (targetId === '#' || targetId === '#0') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          const headerOffset = 80;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      });
    });
  }

  // =============================================
  // 10. IMAGE LAZY LOAD ENHANCEMENT
  // Fade in images as they load
  // =============================================

  function initImageFadeIn() {
    if (window.innerWidth <= 768) return;
    // Only apply to images below the fold for faster perceived loading
    const viewportHeight = window.innerHeight;
    document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      if (img.complete) return;
      // Skip images near the top of the page — they should appear instantly
      const rect = img.getBoundingClientRect();
      if (rect.top < viewportHeight * 1.5) return;

      img.style.opacity = '0';
      img.style.transition = 'opacity 0.4s ease';

      const showImage = () => { img.style.opacity = '1'; };
      img.addEventListener('load', showImage, { once: true });
      // Fallback: ensure image becomes visible quickly
      setTimeout(() => { img.style.opacity = '1'; }, 1000);
    });
  }

  // =============================================
  // 11. BUTTON RIPPLE EFFECT
  // Material-style ripple on primary buttons
  // =============================================

  function initButtonRipple() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.button--primary, .btn-primary, .cta-button, [data-ripple]');
      if (!btn) return;

      const rect = btn.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;

      const ripple = document.createElement('span');
      ripple.className = 'btn-ripple';
      ripple.style.cssText = `width:${size}px;height:${size}px;left:${x}px;top:${y}px;`;
      btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(ripple);

      ripple.addEventListener('animationend', () => ripple.remove(), { once: true });
    });
  }

  // =============================================
  // 12. TYPEWRITER EFFECT
  // Type out text character by character
  // =============================================

  function initTypewriter() {
    const twObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          twObserver.unobserve(el);

          const text = el.dataset.typewriter || el.textContent;
          const speed = parseInt(el.dataset.typewriterSpeed, 10) || 50;
          el.textContent = '';
          el.style.visibility = 'visible';

          let i = 0;
          function type() {
            if (i < text.length) {
              el.textContent += text.charAt(i);
              i++;
              setTimeout(type, speed);
            }
          }
          type();
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll('[data-animate="typewriter"], [data-typewriter]').forEach((el) => {
      el.style.visibility = 'hidden';
      twObserver.observe(el);
    });
  }

  // =============================================
  // 13. ADD TO CART ANIMATION
  // Bounce + fly-to-cart effect
  // =============================================

  function initAddToCartAnimation() {
    document.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[name="add"], .add-to-cart-btn, .product-form__submit');
      if (!addBtn) return;

      // Bounce the button
      addBtn.classList.add('atc-bounce');
      addBtn.addEventListener('animationend', () => addBtn.classList.remove('atc-bounce'), { once: true });

      // Animate cart icon
      const cartIcon = document.querySelector('.cart-icon-bubble, .header__icon--cart, [data-cart-icon]');
      if (cartIcon) {
        cartIcon.classList.add('cart-ping');
        setTimeout(() => cartIcon.classList.remove('cart-ping'), 800);
      }
    });
  }

  // =============================================
  // 14. NAVIGATION UNDERLINE SLIDE
  // Animated underline follows active nav item
  // =============================================

  function initNavUnderline() {
    const nav = document.querySelector('.header__inline-menu, nav.primary-nav');
    if (!nav) return;

    const links = nav.querySelectorAll('a');
    if (links.length === 0) return;

    const indicator = document.createElement('span');
    indicator.className = 'nav-underline-indicator';
    nav.style.position = 'relative';
    nav.appendChild(indicator);

    function moveIndicator(link) {
      const rect = link.getBoundingClientRect();
      const navRect = nav.getBoundingClientRect();
      indicator.style.width = rect.width + 'px';
      indicator.style.left = (rect.left - navRect.left) + 'px';
      indicator.style.opacity = '1';
    }

    links.forEach((link) => {
      link.addEventListener('mouseenter', () => moveIndicator(link));
    });

    nav.addEventListener('mouseleave', () => {
      // Return to active link or hide
      const active = nav.querySelector('a[aria-current="page"], a.active');
      if (active) {
        moveIndicator(active);
      } else {
        indicator.style.opacity = '0';
      }
    });

    // Set initial position on active link
    const active = nav.querySelector('a[aria-current="page"], a.active');
    if (active) moveIndicator(active);
  }

  // =============================================
  // 15. FORM FOCUS ANIMATIONS
  // Float labels + border color transition
  // =============================================

  function initFormAnimations() {
    document.querySelectorAll('.field__input, .form__input, input[type="text"], input[type="email"], textarea').forEach((input) => {
      const label = input.parentElement?.querySelector('label, .field__label');
      if (!label) return;

      function checkFilled() {
        if (input.value.trim() !== '') {
          input.classList.add('input--filled');
        } else {
          input.classList.remove('input--filled');
        }
      }

      input.addEventListener('focus', () => input.classList.add('input--focused'));
      input.addEventListener('blur', () => {
        input.classList.remove('input--focused');
        checkFilled();
      });
      checkFilled();
    });
  }

  // =============================================
  // 16. MOBILE BOTTOM NAVIGATION
  // Sticky bottom nav on mobile
  // =============================================

  function initMobileBottomNav() {
    if (document.body.classList.contains('landing-page')) return;
    if (window.innerWidth >= 750) return;
    if (document.querySelector('.mobile-bottom-nav')) return;

    const nav = document.createElement('nav');
    nav.className = 'mobile-bottom-nav';
    nav.setAttribute('aria-label', 'Mobile navigation');
    nav.innerHTML = `
      <a href="/" class="mobile-bottom-nav__item" aria-label="Home">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
        <span>Home</span>
      </a>
      <a href="/collections" class="mobile-bottom-nav__item" aria-label="Shop">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
        <span>Shop</span>
      </a>
      <a href="/search" class="mobile-bottom-nav__item" aria-label="Search">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <span>Search</span>
      </a>
      <a href="/cart" class="mobile-bottom-nav__item" aria-label="Cart">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>
        <span>Cart</span>
      </a>
    `;
    document.body.appendChild(nav);

    // Highlight current page
    const path = window.location.pathname;
    nav.querySelectorAll('a').forEach((a) => {
      const href = a.getAttribute('href');
      if (path === href || (href !== '/' && path.startsWith(href))) {
        a.classList.add('active');
      }
    });

    // Auto-hide on scroll down, show on scroll up
    let lastY = 0;
    let navTicking = false;
    window.addEventListener('scroll', () => {
      if (navTicking) return;
      navTicking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y > lastY && y > 100) {
          nav.classList.add('hidden');
        } else {
          nav.classList.remove('hidden');
        }
        lastY = y;
        navTicking = false;
      });
    }, { passive: true });
  }

  // =============================================
  // 17. STICKY ADD-TO-CART (MOBILE)
  // Fixed bottom bar on product pages
  // =============================================

  function initStickyAddToCart() {
    if (window.innerWidth >= 750) return;

    const form = document.querySelector('product-form, .product-form');
    const addBtn = document.querySelector('[name="add"], .product-form__submit');
    const priceEl = document.querySelector('.price__regular .price-item--regular, .price-item--sale');
    const titleEl = document.querySelector('.product-details h1, .product__title, [data-product-title]');
    if (!form || !addBtn) return;

    const productTitle = titleEl ? titleEl.textContent.trim() : '';
    const priceText = priceEl ? priceEl.textContent.trim() : '';

    const sticky = document.createElement('div');
    sticky.className = 'sticky-atc-bar';
    sticky.innerHTML = `
      <div class="sticky-atc-bar__info">
        <div class="sticky-atc-bar__title">${productTitle}</div>
        <div class="sticky-atc-bar__price">${priceText}</div>
      </div>
      <button type="button" class="sticky-atc-bar__btn">${addBtn.textContent.trim()}</button>
    `;
    document.body.appendChild(sticky);

    sticky.querySelector('.sticky-atc-bar__btn').addEventListener('click', () => {
      addBtn.click();
    });

    // Update price when variant changes
    document.addEventListener('theme:variant:change', () => {
      const newPrice = document.querySelector('.price__regular .price-item--regular, .price-item--sale');
      const stickyPrice = sticky.querySelector('.sticky-atc-bar__price');
      if (newPrice && stickyPrice) stickyPrice.textContent = newPrice.textContent.trim();
    });

    // Show only when original button is out of view
    const observer = new IntersectionObserver(
      ([entry]) => {
        sticky.classList.toggle('visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(addBtn);
  }

  // =============================================
  // 18. SKELETON SCREEN LOADER
  // Replace spinners with skeleton placeholders
  // =============================================

  function initSkeletonLoaders() {
    // Convert any loading spinners to skeleton loaders
    document.querySelectorAll('.loading, .loading-overlay, [data-loading]').forEach((el) => {
      if (!el.querySelector('.skeleton-pulse')) {
        el.classList.add('skeleton-container');
      }
    });
  }

  // =============================================
  // INITIALIZATION
  // Run everything on DOM ready
  // =============================================

  function init() {
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      // Still show everything, just no animations
      document.querySelectorAll('.shopify-section').forEach((s) => {
        s.classList.add('section-visible');
      });
      // Still init functional features (not motion-dependent)
      initFormAnimations();
      initMobileBottomNav();
      initStickyAddToCart();
      return;
    }

    initScrollReveals();
    initCursorGlow();
    initCounters();
    initParallax();
    initMagneticButtons();
    initSmoothAnchors();
    initImageFadeIn();
    initButtonRipple();
    initTypewriter();
    initAddToCartAnimation();
    initNavUnderline();
    initFormAnimations();
    initMobileBottomNav();
    initStickyAddToCart();
    initSkeletonLoaders();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load/select (Theme Editor)
  document.addEventListener('shopify:section:load', () => {
    initScrollReveals();
    initCounters();
    initImageFadeIn();
    initFormAnimations();
    initSkeletonLoaders();
  });
})();
